import React from "react";

export const EducationItem = ({ date, school, description }) => {
  return (
    <div className="education-item">

      <div>
        <h3 className="h-date">{date}</h3>
      </div>

      <div className="education-description">
        <h2 className="h-school">{school}</h2>
        <p className="p-description">{description}</p>
      </div>
      <hr/>
    </div>
  );
};
